<template>
  <div class="business_type">
    <div class="header_task">
      <el-row>
        <el-col :span='12'>
          <el-button @click="tableChange('1')" size="small" :class="{ activeBtn: sign == '1' }"
            style="width:100px">收入</el-button>
          <el-button @click="tableChange('0')" size='small' :class="{ activeBtn: sign == '0' }"
            style="width:100px">支出</el-button>
        </el-col>
        <el-col :span='12' style="text-align:right">
          <el-button v-for="item in headerButton" :key="item.id" size="small" style="width:90px;"
            :class="{ activeBtn: item.permission == 'bank:businessType:add' }"
            @click="headerTask(item)">{{ item.name || item.label }}</el-button>
        </el-col>
      </el-row>
    </div>
    <PublicTable :table="tableData">
      <template slot-scope="props" slot="operation">
        <el-button type="text" v-for="item in props.scope.row.buttons" :key="item.id"
          @click="tableTask(item, props.scope.row)" :class="{ warningColor: item.permission == 'bank:businessType:delete' }">
          {{ item.name || item.label }}
        </el-button>
      </template>
    </PublicTable>

    <!-- 新增业务类型 -->
    <AddBusinessType ref='addBusinessType' @saveSuccess="saveSuccess"></AddBusinessType>
  </div>
</template>

<script>
import AddBusinessType from '@/components/dialog/addBusinessType'
import PublicTable from '@/components/publicTable'
import { findBankBusinessType, deleteBankBusinessType } from '@/api'
export default {
  components: {
    AddBusinessType,
    PublicTable
  },
  data() {
    return {
      ids: '',
      cid: '',
      sign: "1",
      headerButton: [],
      tableButton: [],
      tableData: {
        border: true,				// 是否带有纵向边框
        stripe: true,				// 是否带有斑马纹
        loading: false,		// 是否显示加载动画
        hasSelect: true,			// 是否显示多选
        hasOperation: false,		// 是否有操作功能
        hasContextmenu: false,		// 是否有右键功能
        hasShowSummary: false,		// 是否显示合计行
        hasShowPagination: false,	// 是否显示分页
        key: 0,
        data: [],
        center: {
          textAlign: 'center',
        },
        config: [
          {
            label: '行次',
            value: 'count',
            show: 'normal',
          },
          {
            label: '业务类型名称',
            value: 'name',
            show: 'normal',
          },
          {
            label: '收支方向',
            value: 'from',
            show: 'normal',
          },
          {
            label: '借方',
            value: 'debit',
            show: 'normal',
          },
          {
            label: '贷方',
            value: 'creditor',
            show: 'normal'
          },
          {
            label: '操作',
            value: 'operation',
            show: 'template'
          }
        ],
        toggleRowSelection: this.toggleRowSelection,
      }

    }
  },
  created() {
    this.getButton()
    this.cid = sessionStorage.getItem('cid');
  },
  mounted() {
    this.getBusinessType()
  },
  methods: {
    // 全选
    toggleRowSelection(val) {
      ;
      const _ = this;
      const ids = val.map(item => item.id);
      this.ids = ids.toString();
    },
    /** 删除业务类型 */
    deleteTask({ row, isMutilple }) {
      let params = {
        cid: this.cid,
        ids: ""
      }
      if (isMutilple) {
        params.ids = this.ids
      } else {
        params.ids = row.id
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBankBusinessType(params).then(res => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg)
            this.getBusinessType()
          }
        })
      })
    },
    saveSuccess() {
      this.getBusinessType()
    },
    /** 获取业务类型 */
    getBusinessType() {
      let params = {
        cid: this.cid,
        type: this.sign
      }
      findBankBusinessType(params).then(res => {
        if (res.data.code == 1) {
          this.tableData.data = res.data.data.filter((e, i) => {
            if (e.creditor && e.creditor.indexOf('&nbsp') > -1) {
              e.creditor = e.creditor.slice(e.creditor.lastIndexOf('&') + 6)
            }
            if (e.debit && e.debit.indexOf('&nbsp') > -1) {
              e.debit = e.debit.slice(e.debit.lastIndexOf('&') + 6)
            }
            this.$set(e, 'from', this.sign == 1 ? '收入' : '支出')
            this.$set(e, 'count', i + 1)
            return e
          })
        }
      })
    },
    headerTask(item) {
      if (item.permission == 'bank:businessType:add') {
        this.$refs.addBusinessType.handleOpen('新增', { type: this.sign })
      } else if (item.permission == 'bank:businessType:datchdelete') {
        if (this.ids.length == 0) {
          this.$message.warning('请选择数据')
          return
        }
        this.deleteTask({ isMutilple: true })
      }
    },
    tableTask(btn, row) {
      if (btn.permission == 'bank:businessType:edit') {
        this.$refs.addBusinessType.handleOpen('修改', row)
      } else if (btn.permission == 'bank:businessType:delete') {
        this.deleteTask({ row, isMutilple: false })
      }
    },
    getButton() {
      const arr = ['bank:businessType:add', 'bank:businessType:datchdelete']
      let params = {
        permissions: arr.join(',')
      }
      try {
        this.$http.post('sys/menu/findPermissionMenu', params).then(res => {
          if (res && res.data.code == 1) {
            if (res.data.data.length) {
              this.headerButton = res.data.data;
            }
          }
        })
      } catch (e) {
      }
    },
    tableChange(sign) {
      this.sign = sign
      this.getBusinessType()
    },
  }
}
</script>

<style scoped lang='less'>
.warningColor {
  color: #FF6010;
}

.activeBtn {
  background: #269D7B;
  color: #fff;
}

.business_type {
  background: #fff;
  padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 152px);

  .header_task {
    margin-bottom: 20px;
  }
}</style>



// WEBPACK FOOTER //
// src/pages/cashier/business_type.vue